import { useEffect, useRef, useState, useCallback } from "react";
import { configsService } from "../../../Services/configs.service";
import { normalizeEmailList } from "../../../components/ReportConfig/vehicleGroupReportConfig.utils";

/**
 * Gerencia o estado de e-mails por tipo de relatório para a tela VehiclesConfig.
 *
 * @param {{ vehicleGroupId: number|string, reportTypes: Array<{key: string, codeReport: number}> }} params
 */
export function useEmailConfiguration({ vehicleGroupId, reportTypes }) {
  const [emailsByReport, setEmailsByReport] = useState({});
  const [loadingButtons, setLoadingButtons] = useState({});

  const reportTypesRef = useRef(reportTypes);
  const vehicleGroupIdRef = useRef(vehicleGroupId);
  useEffect(() => {
    reportTypesRef.current = reportTypes;
    vehicleGroupIdRef.current = vehicleGroupId;
  });

  const fetchEmails = useCallback(async (reportKey) => {
    const currentVehicleGroupId = vehicleGroupIdRef.current;
    const currentReportTypes = reportTypesRef.current;

    if (!currentVehicleGroupId || !currentReportTypes?.length) return;

    if (reportKey) {
      const type = currentReportTypes.find((t) => t.key === reportKey);
      if (!type) return;

      try {
        const response = await configsService.fetchEmailConfiguration(
          currentVehicleGroupId,
          type.codeReport
        );

        setEmailsByReport((prev) => ({
          ...prev,
          [reportKey]: {
            codeReport: type.codeReport,
            email: prev[reportKey]?.email || "",
            error: "",
            list: normalizeEmailList(response),
          },
        }));
      } catch (error) {
        console.error(`Erro ao carregar emails para ${reportKey}:`, error);
      }
    } else {
      try {
        const promises = currentReportTypes.map((type) =>
          configsService.fetchEmailConfiguration(currentVehicleGroupId, type.codeReport)
        );

        const responses = await Promise.all(promises);

        const grouped = {};
        currentReportTypes.forEach((type, index) => {
          grouped[type.key] = {
            codeReport: type.codeReport,
            email: "",
            error: "",
            list: normalizeEmailList(responses[index]),
          };
        });

        setEmailsByReport(grouped);
      } catch (error) {
        console.error("Erro ao carregar emails:", error);
      }
    }
  }, []);

  return {
    emailsByReport,
    setEmailsByReport,
    loadingButtons,
    setLoadingButtons,
    fetchEmails,
  };
}
